import React, { Component } from 'react';
import { Calendar, Users, Package, Clock, X, CheckCircle, AlertCircle, ArrowRight } from 'lucide-react';
import host from '../../assets/js/Host';
class EmployeeReports extends Component {
  getDefaultDates = () => {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const formatDate = (date) => {
      return date.toISOString().split('T')[0]; // YYYY-MM-DD format
    };

    return {
      fromDate: formatDate(yesterday),
      toDate: formatDate(today)
    };
  };

  constructor(props) {
    super(props);
    const { fromDate, toDate } = this.getDefaultDates();
    this.state = {
      employees: [],
      loading: false,
      error: null,
      fromDate,
      toDate
    };
  }

  componentDidMount() {
    this.fetchReports();
  }

  formatDateForAPI = (dateString) => {
    // تحويل من YYYY-MM-DD إلى DD/MM/YYYY للـ API
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  formatDateForDisplay = (dateString) => {
    // تحويل من YYYY-MM-DD إلى DD/MM/YYYY للعرض
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  fetchReports = async () => {
    this.setState({ loading: true, error: null });

    try {
      const { fromDate, toDate } = this.state;
      const formattedFromDate = this.formatDateForAPI(fromDate);
      const formattedToDate = this.formatDateForAPI(toDate);

      const response = await fetch(
        `${host}dashbord/gets/users/reprots?fromDate=${formattedFromDate}&toDate=${formattedToDate}`
      );

      if (!response.ok) {
        throw new Error('فشل في جلب البيانات');
      }


      const data = await response.json();
      this.setState({ employees: data, loading: false });
    } catch (error) {
      this.setState({ error: error.message, loading: false });
      // استخدام البيانات التجريبية في حالة فشل الاتصال
      this.setState({
        employees: [
          {
            userId: 40,
            userName: "web",
            userPhone: "1992",
            pageName: "عيون المستقبل",
            isActive: 0,
            role: 0,
            isSuperUser: 0,
            shiftStart: 0,
            shiftEnd: 0,
            totalOrders: "2614",
            waitingOrders: "204",
            deliveryOrders: "1837",
            missOrders: "126",
            newOrders: "0",
            rejectedOrders: "19",
            cancelledOrders: "428",
            totalRevenue: 61681,
            deliveryPercentage: "70.28",
            rejectedPercentage: "0.73"
          },
          {
            userId: 45,
            userName: "احمد",
            userPhone: "199000",
            pageName: "عيون المستقبل",
            isActive: 0,
            role: 0,
            isSuperUser: 0,
            shiftStart: 0,
            shiftEnd: 0,
            totalOrders: "113",
            waitingOrders: "1",
            deliveryOrders: "107",
            missOrders: "0",
            newOrders: "0",
            rejectedOrders: "0",
            cancelledOrders: "5",
            totalRevenue: 6341,
            deliveryPercentage: "94.69",
            rejectedPercentage: "0.00"
          },
          {
            userId: 133,
            userName: "رحمة",
            userPhone: "0066",
            pageName: "عيون المستقبل",
            isActive: 0,
            role: 0,
            isSuperUser: 0,
            shiftStart: 13,
            shiftEnd: 20,
            totalOrders: "95",
            waitingOrders: "5",
            deliveryOrders: "75",
            missOrders: "0",
            newOrders: "0",
            rejectedOrders: "1",
            cancelledOrders: "13",
            totalRevenue: 6303,
            deliveryPercentage: "78.95",
            rejectedPercentage: "1.05"
          }
        ],
        loading: false
      });
    }
  };

  handleDateChange = (field, value) => {
    this.setState({ [field]: value });
  };

  handleSearch = () => {
    this.fetchReports();
  };

  getPerformanceColor = (percentage) => {
    const perf = parseFloat(percentage);
    if (perf >= 90) return 'text-green-600 bg-green-100';
    if (perf >= 70) return 'text-yellow-600 bg-yellow-100';
    return 'text-red-600 bg-red-100';
  };

  handleGoBack = () => {
    window.history.back();
  };

  render() {
    const { employees, loading, error, fromDate, toDate } = this.state;

    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        fontFamily: 'Arial, sans-serif',
        direction: 'rtl'
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '20px',
          position: 'relative'
        }}>
          {/* Back Button */}
          <button
            onClick={this.handleGoBack}
            style={{
              position: 'absolute',
              left: '20px',
              top: '20px',
              background: 'rgba(255, 255, 255, 0.9)',
              border: '2px solid #e2e8f0',
              borderRadius: '12px',
              padding: '12px 20px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '600',
              color: '#4a5568',
              transition: 'all 0.3s ease',
              zIndex: 10,
              backdropFilter: 'blur(10px)',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(102, 126, 234, 0.1)';
              e.target.style.borderColor = '#667eea';
              e.target.style.color = '#667eea';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.9)';
              e.target.style.borderColor = '#e2e8f0';
              e.target.style.color = '#4a5568';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
            }}
          >
            <ArrowRight style={{ width: '20px', height: '20px' }} />
            رجوع
          </button>

          {/* Header */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '20px',
            padding: '30px',
            marginBottom: '25px',
            marginTop: '60px',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
            backdropFilter: 'blur(10px)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '25px'
            }}>
              <Users style={{
                width: '40px',
                height: '40px',
                color: '#667eea',
                marginLeft: '15px'
              }} />
              <h1 style={{
                fontSize: '2.5rem',
                fontWeight: 'bold',
                color: '#2d3748',
                margin: 0
              }}>
                تقارير الموظفين
              </h1>
            </div>

            {/* Date Filters */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '20px',
              alignItems: 'end'
            }}>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#4a5568',
                  marginBottom: '8px'
                }}>
                  من تاريخ ({this.formatDateForDisplay(fromDate)})
                </label>
                <div style={{ position: 'relative' }}>
                  <Calendar style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '20px',
                    height: '20px',
                    color: '#667eea'
                  }} />
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => this.handleDateChange('fromDate', e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px 45px 12px 15px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#4a5568',
                  marginBottom: '8px'
                }}>
                  إلى تاريخ ({this.formatDateForDisplay(toDate)})
                </label>
                <div style={{ position: 'relative' }}>
                  <Calendar style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '20px',
                    height: '20px',
                    color: '#667eea'
                  }} />
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => this.handleDateChange('toDate', e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px 45px 12px 15px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>
              </div>

              <button
                onClick={this.handleSearch}
                disabled={loading}
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  padding: '12px 30px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  transform: loading ? 'scale(1)' : 'scale(1)',
                  opacity: loading ? 0.7 : 1
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 10px 25px rgba(102, 126, 234, 0.4)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!loading) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }
                }}
              >
                {loading ? 'جاري البحث...' : 'بحث'}
              </button>
            </div>
          </div>

          {/* Error Message */}
          {error && (
            <div style={{
              background: 'rgba(254, 202, 202, 0.9)',
              border: '1px solid #fc8181',
              borderRadius: '12px',
              padding: '15px',
              marginBottom: '20px',
              color: '#c53030',
              display: 'flex',
              alignItems: 'center'
            }}>
              <AlertCircle style={{ width: '20px', height: '20px', marginLeft: '10px' }} />
              خطأ: {error} (سيتم عرض البيانات التجريبية)
            </div>
          )}

          {/* Loading State */}
          {loading && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px'
            }}>
              <div style={{
                width: '50px',
                height: '50px',
                border: '4px solid #e2e8f0',
                borderTop: '4px solid #667eea',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }} />
            </div>
          )}

          {/* Employees Grid */}
          {!loading && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))',
              gap: '25px'
            }}>
              {employees.map((employee) => (
                <div
                  key={employee.userId}
                  style={{
                    background: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '20px',
                    padding: '25px',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                    backdropFilter: 'blur(10px)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  {/* Employee Header */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '20px',
                    paddingBottom: '15px',
                    borderBottom: '2px solid #f7fafc'
                  }}>
                    <div style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '1.5rem',
                      fontWeight: 'bold',
                      marginLeft: '15px'
                    }}>
                      {employee.userName.charAt(0)}
                    </div>
                    <div>
                      <h3 style={{
                        fontSize: '1.4rem',
                        fontWeight: 'bold',
                        color: '#2d3748',
                        margin: '0 0 5px 0'
                      }}>
                        {employee.userName}
                      </h3>
                      <p style={{
                        color: '#718096',
                        margin: 0,
                        fontSize: '0.9rem'
                      }}>
                        {employee.userPhone}
                      </p>
                    </div>
                  </div>

                  {/* Order Statistics */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                    gap: '12px',
                    marginBottom: '20px'
                  }}>
                    <div style={{
                      padding: '10px',
                      borderRadius: '10px',
                      background: '#f0f4ff',
                      border: '1px solid #e0e7ff',
                      textAlign: 'center'
                    }}>
                      <Package style={{
                        width: '20px',
                        height: '20px',
                        color: '#667eea',
                        margin: '0 auto 5px'
                      }} />
                      <div style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        color: '#2d3748'
                      }}>
                        {employee.totalOrders}
                      </div>
                      <div style={{ fontSize: '0.7rem', color: '#718096' }}>
                        إجمالي الطلبات
                      </div>
                    </div>

                    <div style={{
                      padding: '10px',
                      borderRadius: '10px',
                      background: '#f0fff4',
                      border: '1px solid #c6f6d5',
                      textAlign: 'center'
                    }}>
                      <CheckCircle style={{
                        width: '20px',
                        height: '20px',
                        color: '#48bb78',
                        margin: '0 auto 5px'
                      }} />
                      <div style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        color: '#2d3748'
                      }}>
                        {employee.deliveryOrders}
                      </div>
                      <div style={{ fontSize: '0.7rem', color: '#718096' }}>
                        مسلمة
                      </div>
                    </div>

                    <div style={{
                      padding: '10px',
                      borderRadius: '10px',
                      background: '#fffbf0',
                      border: '1px solid #feebc8',
                      textAlign: 'center'
                    }}>
                      <Clock style={{
                        width: '20px',
                        height: '20px',
                        color: '#ed8936',
                        margin: '0 auto 5px'
                      }} />
                      <div style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        color: '#2d3748'
                      }}>
                        {employee.waitingOrders}
                      </div>
                      <div style={{ fontSize: '0.7rem', color: '#718096' }}>
                        منتظرة
                      </div>
                    </div>

                    <div style={{
                      padding: '10px',
                      borderRadius: '10px',
                      background: '#fef5e7',
                      border: '1px solid #fbd38d',
                      textAlign: 'center'
                    }}>
                      <AlertCircle style={{
                        width: '20px',
                        height: '20px',
                        color: '#d69e2e',
                        margin: '0 auto 5px'
                      }} />
                      <div style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        color: '#2d3748'
                      }}>
                        {employee.missOrders}
                      </div>
                      <div style={{ fontSize: '0.7rem', color: '#718096' }}>
                        فائتة
                      </div>
                    </div>

                    <div style={{
                      padding: '10px',
                      borderRadius: '10px',
                      background: '#fff5f5',
                      border: '1px solid #fed7d7',
                      textAlign: 'center'
                    }}>
                      <X style={{
                        width: '20px',
                        height: '20px',
                        color: '#e53e3e',
                        margin: '0 auto 5px'
                      }} />
                      <div style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        color: '#2d3748'
                      }}>
                        {employee.rejectedOrders}
                      </div>
                      <div style={{ fontSize: '0.7rem', color: '#718096' }}>
                        مرفوضة
                      </div>
                    </div>

                    <div style={{
                      padding: '10px',
                      borderRadius: '10px',
                      background: '#f7fafc',
                      border: '1px solid #e2e8f0',
                      textAlign: 'center'
                    }}>
                      <X style={{
                        width: '20px',
                        height: '20px',
                        color: '#718096',
                        margin: '0 auto 5px'
                      }} />
                      <div style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        color: '#2d3748'
                      }}>
                        {employee.cancelledOrders}
                      </div>
                      <div style={{ fontSize: '0.7rem', color: '#718096' }}>
                        ملغاة
                      </div>
                    </div>
                  </div>

                  {/* Performance Metrics */}
                  <div style={{ marginBottom: '15px' }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '8px'
                    }}>
                      <span style={{ fontSize: '0.9rem', color: '#4a5568' }}>
                        نسبة التسليم
                      </span>
                      <span style={{
                        fontSize: '0.9rem',
                        fontWeight: 'bold',
                        padding: '2px 8px',
                        borderRadius: '8px',
                        ...this.getPerformanceColor(employee.deliveryPercentage).split(' ').reduce((acc, cls) => {
                          if (cls.includes('text-')) acc.color = cls.replace('text-', '').replace('-600', '') === 'green' ? '#38a169' : cls.replace('text-', '').replace('-600', '') === 'yellow' ? '#d69e2e' : '#e53e3e';
                          if (cls.includes('bg-')) acc.background = cls.replace('bg-', '').replace('-100', '') === 'green' ? '#f0fff4' : cls.replace('bg-', '').replace('-100', '') === 'yellow' ? '#fffff0' : '#fed7d7';
                          return acc;
                        }, {})
                      }}>
                        {employee.deliveryPercentage}%
                      </span>
                    </div>
                    <div style={{
                      width: '100%',
                      height: '8px',
                      backgroundColor: '#e2e8f0',
                      borderRadius: '4px',
                      overflow: 'hidden'
                    }}>
                      <div style={{
                        width: `${employee.deliveryPercentage}%`,
                        height: '100%',
                        background: parseFloat(employee.deliveryPercentage) >= 90 ? '#48bb78' : parseFloat(employee.deliveryPercentage) >= 70 ? '#ed8936' : '#f56565',
                        transition: 'width 0.3s ease'
                      }} />
                    </div>
                  </div>

                  {/* Additional Information */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '15px',
                    marginTop: '15px',
                    padding: '15px',
                    background: '#f7fafc',
                    borderRadius: '12px',
                    fontSize: '0.85rem'
                  }}>
                    <div>
                      <span style={{ color: '#718096' }}>نسبة الرفض: </span>
                      <span style={{ fontWeight: 'bold', color: '#e53e3e' }}>
                        {employee.rejectedPercentage}%
                      </span>
                    </div>
                    <div>
                      <span style={{ color: '#718096' }}>نوبة العمل: </span>
                      <span style={{ fontWeight: 'bold', color: '#2d3748' }}>
                        {employee.shiftStart && employee.shiftEnd
                          ? `${employee.shiftStart}:00 - ${employee.shiftEnd}:00`
                          : 'غير محدد'
                        }
                      </span>
                    </div>
                    <div>
                      <span style={{ color: '#718096' }}>رقم المستخدم: </span>
                      <span style={{ fontWeight: 'bold', color: '#2d3748' }}>
                        {employee.userId}
                      </span>
                    </div>
                    <div>
                      <span style={{ color: '#718096' }}>الحالة: </span>
                      <span style={{
                        fontWeight: 'bold',
                        color: employee.isActive ? '#48bb78' : '#e53e3e'
                      }}>
                        {employee.isActive ? 'نشط' : 'غير نشط'}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>

        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @media (max-width: 768px) {
            .grid {
              grid-template-columns: 1fr !important;
            }
          }
          
          @media (max-width: 480px) {
            .container {
              padding: 10px !important;
            }
            
            .card {
              padding: 15px !important;
            }
            
            .header-title {
              font-size: 1.8rem !important;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default EmployeeReports;